import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { logError } from 'utils/logging';
import Error500 from 'components/Error500';


class ErrorBoundary extends Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch (error, info) {
    const { onError } = this.props;
    this.setState({ hasError: true });

    console.error(error);
    logError(error, info);
    onError && onError(error, info);
  }

  render () {
    const { children } = this.props;
    const { hasError } = this.state;

    return hasError ? <Error500 /> : children;
  }
}

ErrorBoundary.propTypes = {
  onError: PropTypes.func,
  children: PropTypes.node,
};

export default ErrorBoundary;
